import React, { useState, useCallback, useRef, useEffect } from "react";
import "react-image-crop/dist/ReactCrop.css";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Cropper from "react-easy-crop";
import Modal from "react-modal";
import styles from "./styles";
import { getCroppedImg } from "../../../utilities/canvasUtils";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import LachakToranjRug from "../rugTemplates/lachakToranjRug";
import AfshanRug from "../rugTemplates/afshanRug";
import KheshtiRug from "../rugTemplates/kheshtiRug";
import ModernRug from "../rugTemplates/modernRug";
import RugAPI from "../../../api/rug";

const customStyles = {
  content: {
    width: "100%",
    height: "100vh",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    padding: 0,
    zIndex: 100,
    border: "none",
  },
};

export default function YourRugTabs(props) {
  const { itemsScrollHandler, selectTabInYourRug, selectedSizeRug, texts, selectedRugPreview, setUserInfo, yourPicSelectedParts, addYourPicToWishList } = props;

  const [sizeList, setSizeList] = useState([]);
  const [selectedSizeId, setSelectedSizeId] = useState("");

  const isMobile = useMediaQuery("(max-width: 768px)");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedImageFile, setCroppedImageFile] = useState(null);
  const [aspect, setAspect] = useState(4 / 3);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const inputRef = useRef();
  const [cropModal, setCropModal] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imgUri, setImageUri] = useState();
  const [defaultImage, setDefaultImage] = useState("");

  const [yourPicSelectedPartsLocal, setyourPicSelectedParts] = useState(yourPicSelectedParts);

  const classes = styles();

  const handleCropChange = useCallback((c) => setCrop(c), []);
  const handleZoomChange = useCallback((z) => setZoom(z), []);

  const rugSize = () => {
    const rugAPIObj = new RugAPI();
    rugAPIObj
      .getRugSize()
      .then((res) => {
        setSizeList(res.data);
      })
      .catch(() => { });
  };

  const handleScroll = () => {
    const slider = document.getElementById("partsSlider");

    if (slider && slider.scrollLeft < 600) {
      itemsScrollHandler && itemsScrollHandler();
    }
  };

  const handleManualScroll = (direction) => {
    const slider = document.getElementById("partsSlider");
    if (!slider) return;
    switch (direction) {
      case "right":
        slider.scrollLeft -= 120;
        break;
      default:
        slider.scrollLeft += 120;
        break;
    }

    handleScroll();
  };

  useEffect(() => {
    rugSize();
  }, []);

  const onSelectFile = (e) => {
    //if (e.target.files && e.target.files.length > 0) {
      const readerr = new FileReader();
      readerr.addEventListener("load", () => {
        setImageUri(readerr.result);
      });
      readerr.readAsDataURL(e.target.files[0]);
      setAspect(selectedSizeRug?.width / selectedSizeRug?.height);
      setCropModal(true);
    //} else {
    //  setImageUri(imgUri);
    //}
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);


  const urlToObject = async () => {
    const response = await fetch("./static/img/pic2.jpg");
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    setDefaultImage(file);
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const showCroppedImage = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(imgUri, croppedAreaPixels, rotation);
      let img = dataURLtoFile(cropped, "corpet.png");
      setCroppedImageFile(img);
      setUserInfo && setUserInfo({ image: img });
      setCroppedImage(cropped);
      setCropModal(false);


      setyourPicSelectedParts({
        type: "your_picture",
        background: {
          id: 0,
          image: cropped
        },
        pattern: {},
      });

      addYourPicToWishList({
        type: "your_picture",
        background: {
          id: 0,
          image: cropped
        },
        pattern: {},
      });

      //globalState

      // this.setState({
      //   yourPicSelectedParts: {
      //     type: "your_picture",
      //     background: {},
      //     pattern: {},
      //   },
      // });


    } catch (e) {
      console.error(e);
    }
  }, [imgUri, croppedAreaPixels, rotation, setUserInfo]);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );
  }, [completedCrop]);

  useEffect(() => {
    if (selectedRugPreview) {
      urlToObject();
    }
  }, [selectedRugPreview]);

  const showSelectedRug = (selectedRug) => {
    let rugtype = selectedRug.id ? selectedRug.rug_type : selectedRug.type;
    switch (rugtype) {
      case "kheshti":
        return <KheshtiRug background={selectedRug.background} tile={selectedRug.tile} show={true} />;
      case "afshan":
        return <AfshanRug background={selectedRug.background} border={selectedRug.border} show={true} />;
      case "modern":
        return <ModernRug background={selectedRug.background} pattern={selectedRug.pattern} show={true} />;
      default:
        return (
          <LachakToranjRug
            background={selectedRug.background}
            border={selectedRug.border}
            corner={selectedRug.corner}
            toranj={selectedRug.toranj}
            show={true}
          />
        );
    }
  };

  return (
    <div>
      {/* start upload pic */}
      <div>
        <div>
          <input type="file" ref={inputRef} style={{ display: "none" }} accept=".gif,.jpg,.jpeg,.png" onChange={onSelectFile} />
          {/* {(croppedImage || selectedRugPreview) && (
            <button
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#2bc595",
                color: "#fff",
                alignItems: "center",
                borderRadius: 25,
                paddingRight: 16,
                position: "absolute",
                left: "50%",
                bottom: isMobile ? 54 : 69,
                transform: "translate(-50% , -50%)",
                width: 230,
                height: 40,
              }}
              onClick={() => {
                if (selectedRugPreview) {
                  setUserInfo && setUserInfo({ image: defaultImage });
                }
                selectTabInYourRug && selectTabInYourRug("confirm_and_pay");
              }}
            >
              <span>{texts.confirmation_and_approval}</span>
            </button>
          )} */}
        </div>

        <Modal
          isOpen={cropModal}
          onRequestClose={() => {
            setCropModal(false);
            setCroppedImage("");
          }}
          style={customStyles}
          overlayClassName={classes.myoverlay}
          contentLabel="Example Modal"
        >
          <div className={classes.cropContainer}>
            <Cropper
              image={imgUri}
              crop={crop}
              zoom={zoom}
              aspect={Number.isFinite(aspect) ? aspect : 4 / 3}
              onCropChange={handleCropChange}
              onCropComplete={onCropComplete}
              onZoomChange={handleZoomChange}
            />
          </div>
          <div className={classes.controls}>
            <div className={classes.sliderContainer}>
              <Typography
                variant="overline"
                classes={{ root: classes.sliderLabel }}
              >
                {texts.zoom}
              </Typography>
              <Slider
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="بزرگنمایی"
                classes={{ container: classes.slider }}
                onChange={(e, zoom) => setZoom(zoom)}
                color="secondary"
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              style={{
                backgroundColor: "#06b170",
                color: "#fff",
                padding: 10,
                borderRadius: 4,
              }}
              onClick={showCroppedImage}
            >
              <p>{texts.image_registration}</p>
            </button>
          </div>
        </Modal>
      </div>
      {/* end upload pic  */}

      <div className="text-center your-pic-btn-bar">
        {/* <div className="text-center your-pic-size-bar">
          <span>{texts["selectSizeYourPic"]}</span>
          <select id="size" value={selectedSizeId} onChange={(e) => setSelectedSizeId(e.target.value)}>
            <option value="">--Select--</option>
            {sizeList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div> */}
        <button onClick={() => inputRef.current.click()}>
          <span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.49954 14.7917C7.15788 14.7917 6.87454 14.5084 6.87454 14.1667V10.6751L6.27454 11.2751C6.03288 11.5167 5.63288 11.5167 5.39121 11.2751C5.14954 11.0334 5.14954 10.6334 5.39121 10.3917L7.05788 8.72507C7.23288 8.55007 7.50788 8.49174 7.74121 8.59174C7.97454 8.68341 8.12454 8.91674 8.12454 9.16674V14.1667C8.12454 14.5084 7.84121 14.7917 7.49954 14.7917Z" fill="white" />
              <path d="M9.16654 11.4585C9.0082 11.4585 8.84987 11.4002 8.72487 11.2752L7.0582 9.60853C6.81654 9.36686 6.81654 8.96686 7.0582 8.7252C7.29987 8.48353 7.69987 8.48353 7.94154 8.7252L9.6082 10.3919C9.84987 10.6335 9.84987 11.0335 9.6082 11.2752C9.4832 11.4002 9.32487 11.4585 9.16654 11.4585Z" fill="white" />
              <path d="M12.5003 18.9582H7.50033C2.97533 18.9582 1.04199 17.0248 1.04199 12.4998V7.49984C1.04199 2.97484 2.97533 1.0415 7.50033 1.0415H11.667C12.0087 1.0415 12.292 1.32484 12.292 1.6665C12.292 2.00817 12.0087 2.2915 11.667 2.2915H7.50033C3.65866 2.2915 2.29199 3.65817 2.29199 7.49984V12.4998C2.29199 16.3415 3.65866 17.7082 7.50033 17.7082H12.5003C16.342 17.7082 17.7087 16.3415 17.7087 12.4998V8.33317C17.7087 7.9915 17.992 7.70817 18.3337 7.70817C18.6753 7.70817 18.9587 7.9915 18.9587 8.33317V12.4998C18.9587 17.0248 17.0253 18.9582 12.5003 18.9582Z" fill="white" />
              <path d="M18.3337 8.9584H15.0003C12.1503 8.9584 11.042 7.85007 11.042 5.00007V1.66674C11.042 1.41674 11.192 1.18341 11.4253 1.09174C11.6587 0.991739 11.9253 1.05007 12.1087 1.22507L18.7753 7.89174C18.9503 8.06674 19.0087 8.34174 18.9087 8.57507C18.8087 8.8084 18.5837 8.9584 18.3337 8.9584ZM12.292 3.17507V5.00007C12.292 7.15007 12.8503 7.70841 15.0003 7.70841H16.8253L12.292 3.17507Z" fill="white" />
            </svg>
            {texts["upload"]}
          </span>
        </button>
        <button>
          <span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.3667 18.9582H5.6334C3.30006 18.9582 1.81673 17.5665 1.6834 15.2415L1.25006 8.3665C1.1834 7.32484 1.54173 6.32484 2.2584 5.5665C2.96673 4.80817 3.96673 4.37484 5.00006 4.37484C5.26673 4.37484 5.52506 4.2165 5.65006 3.9665L6.25006 2.77484C6.74173 1.79984 7.97506 1.0415 9.05006 1.0415H10.9584C12.0334 1.0415 13.2584 1.79984 13.7501 2.7665L14.3501 3.98317C14.4751 4.2165 14.7251 4.37484 15.0001 4.37484C16.0334 4.37484 17.0334 4.80817 17.7417 5.5665C18.4584 6.33317 18.8167 7.32484 18.7501 8.3665L18.3167 15.2498C18.1667 17.6082 16.7251 18.9582 14.3667 18.9582ZM9.05006 2.2915C8.4334 2.2915 7.65006 2.77484 7.36673 3.33317L6.76673 4.53317C6.41673 5.20817 5.74173 5.62484 5.00006 5.62484C4.30006 5.62484 3.65006 5.90817 3.16673 6.4165C2.69173 6.92484 2.45006 7.5915 2.50006 8.28317L2.9334 15.1665C3.0334 16.8498 3.94173 17.7082 5.6334 17.7082H14.3667C16.0501 17.7082 16.9584 16.8498 17.0667 15.1665L17.5001 8.28317C17.5417 7.5915 17.3084 6.92484 16.8334 6.4165C16.3501 5.90817 15.7001 5.62484 15.0001 5.62484C14.2584 5.62484 13.5834 5.20817 13.2334 4.54984L12.6251 3.33317C12.3501 2.78317 11.5667 2.29984 10.9501 2.29984H9.05006V2.2915Z" fill="#727D93" />
              <path d="M11.25 7.2915H8.75C8.40833 7.2915 8.125 7.00817 8.125 6.6665C8.125 6.32484 8.40833 6.0415 8.75 6.0415H11.25C11.5917 6.0415 11.875 6.32484 11.875 6.6665C11.875 7.00817 11.5917 7.2915 11.25 7.2915Z" fill="#727D93" />
              <path d="M10.0003 15.6252C8.15866 15.6252 6.66699 14.1335 6.66699 12.2918C6.66699 10.4502 8.15866 8.9585 10.0003 8.9585C11.842 8.9585 13.3337 10.4502 13.3337 12.2918C13.3337 14.1335 11.842 15.6252 10.0003 15.6252ZM10.0003 10.2085C8.85033 10.2085 7.91699 11.1418 7.91699 12.2918C7.91699 13.4418 8.85033 14.3752 10.0003 14.3752C11.1503 14.3752 12.0837 13.4418 12.0837 12.2918C12.0837 11.1418 11.1503 10.2085 10.0003 10.2085Z" fill="#727D93" />
            </svg>
            {texts["camera"]}
          </span>
        </button>
      </div>
      <div className="slider relative">
        <button name="scroll-right" className="m-0 button-shadow-right" onClick={() => handleManualScroll("right")}>
          <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 240.823 240.823" enableBackground="new 0 0 240.823 240.823">
            <g>
              <path id="Chevron_Right_1_" d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179
                                              l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261
                                              C187.881,124.315,187.881,116.495,183.189,111.816z" />
            </g>
          </svg>
        </button>
        <div id="partsSlider" className="p-0 col-11 slides"></div>
        <button name="scroll-left" className="m-0 button-shadow-left" onClick={() => handleManualScroll("left")}>
          <svg version="1.1" x="0px" y="0px" viewBox="0 0 240.823 240.823" enableBackground="new 0 0 240.823 240.823">
            <g>
              <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                              l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                              C52.942,116.507,52.942,124.327,57.633,129.007z" />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
}


